// extracted by mini-css-extract-plugin
module.exports = {"wrap":"index_wrap_1Yvah","cardBox":"index_cardBox_1Q-yR","cardItem":"index_cardItem_2IjjO","other":"index_other_2q403"};